<template>
  <div class="maskConstain">
    <div class="anim">用户ID:{{ getWaterMark }}</div>
  </div>
</template>

<script>
import { getAppInfo } from '@/api/appInfo'

export default {
  name: 'VideoMask',
  computed: {
    getWaterMark() {
      return getAppInfo().uid ? getAppInfo().uid : '--'
    }
  }
}
</script>

<style scoped>
.anim {
  color: #858585;
  position: absolute;
  right: 0;
  top: 0;
  font-size: 16px;
  transform: rotate(45deg);
  animation: syAnim 20s infinite;
  transform-origin: 0% 0%;
}

@-webkit-keyframes syAnim {
  0% {
    transform: rotate(45deg);
    right: 0%;
    top: 0%;
  }
  11.11% {
    transform: rotate(45deg);
    right: 0%;
    top: 0%;
  }
  22.22% {
    transform: rotate(45deg);
    right: 40%;
    top: 40%;
  }
  33.33% {
    transform: rotate(45deg);
    right: 40%;
    top: 40%;
  }
  44.44% {
    transform: rotate(45deg);
    right: 70%;
    top: 55%;
  }
  55.55% {
    transform: rotate(45deg);
    right: 70%;
    top: 55%;
  }
  66.66% {
    transform: rotate(45deg);
    right: 40%;
    top: 40%;
  }
  77.77% {
    transform: rotate(45deg);
    right: 40%;
    top: 40%;
  }
  88.88% {
    transform: rotate(45deg);
    right: 0%;
    top: 0%;
  }
  99.99% {
    transform: rotate(45deg);
    right: 0%;
    top: 0%;
  }
}

.maskConstain {
  display: flex;
  width: 100%;
  position: fixed;
  z-index: 100000;
  pointer-events: none;
}
</style>
